export default "__VITE_ASSET__pWsavvh7__"